import React from "react";
import SecondaryButton from "../buttons/SecondaryButton";
import PrimaryButton from "../buttons/PrimaryButton";

const ConfirmationModal = ({ onDismiss }) => {
  return (
    <div className="bg-white flex flex-col p-4 w-c300 rounded-3xl ">
      <div className="flex flex-col gap-3 w-full">
        <div className="flex flex-row justify-between">
          {" "}
          <div className="text-h3 text-shadow_50">
            Etes vous sûrde vouloir réaliser cette action ?
          </div>
        </div>
        <div className="flex flex-row gap-2 justify-between">
          {" "}
          <PrimaryButton
            className="min-w-fit"
            sx={{ backgroundColor: "red" }}
            onClick={() => onDismiss(true)}
          >
            Confirmer
          </PrimaryButton>
          <SecondaryButton
            className="flex-grow"
            onClick={() => onDismiss(false)}
          >
            Annuler
          </SecondaryButton>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
